import { useEffect, useRef } from "react";
import { Bold, Italic, List, ListOrdered, Heading2, Heading3, Link2, Image as ImageIcon, Eraser, Pilcrow } from "lucide-react";

export default function RichTextEditor({ value, onChange, insertRef, onOpenLibrary }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exec = (cmd, arg = null) => {
    document.execCommand(cmd, false, arg);
    ref.current.focus();
    onChange(ref.current.innerHTML);
  };

  const insertImage = (url) => {
    ref.current.focus();
    exec("insertHTML", `<img src="${url}" alt="" style="max-width:100%;border-radius:4px;margin:12px 0" />`);
  };

  useEffect(() => {
    if (insertRef) insertRef.current = insertImage;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insertRef]);

  const Btn = ({ onClick, title, children }) => (
    <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={onClick} title={title} className="h-8 w-8 flex items-center justify-center rounded-sm text-lp-ink hover:bg-lp-grey">{children}</button>
  );

  return (
    <div className="border border-lp-border rounded-sm">
      <div className="flex flex-wrap gap-1 p-2 border-b border-lp-border bg-lp-grey/50">
        <Btn onClick={() => exec("formatBlock", "<h2>")} title="Heading 2"><Heading2 size={17} /></Btn>
        <Btn onClick={() => exec("formatBlock", "<h3>")} title="Heading 3"><Heading3 size={17} /></Btn>
        <Btn onClick={() => exec("formatBlock", "<p>")} title="Paragraph"><Pilcrow size={16} /></Btn>
        <span className="w-px bg-lp-border mx-1" />
        <Btn onClick={() => exec("bold")} title="Bold"><Bold size={16} /></Btn>
        <Btn onClick={() => exec("italic")} title="Italic"><Italic size={16} /></Btn>
        <span className="w-px bg-lp-border mx-1" />
        <Btn onClick={() => exec("insertUnorderedList")} title="Bullet list"><List size={17} /></Btn>
        <Btn onClick={() => exec("insertOrderedList")} title="Numbered list"><ListOrdered size={17} /></Btn>
        <Btn onClick={() => { const u = prompt("Link URL"); if (u) exec("createLink", u); }} title="Link"><Link2 size={16} /></Btn>
        <Btn onClick={() => onOpenLibrary && onOpenLibrary()} title="Insert image from library"><ImageIcon size={16} /></Btn>
        <Btn onClick={() => exec("removeFormat")} title="Clear formatting"><Eraser size={16} /></Btn>
      </div>
      <div
        ref={ref}
        contentEditable
        data-testid="rte-content"
        onInput={() => onChange(ref.current.innerHTML)}
        className="prose-lp min-h-[220px] max-h-[420px] overflow-y-auto p-4 text-sm focus:outline-none"
        suppressContentEditableWarning
      />
    </div>
  );
}
